import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OrderItemCreateModalUI from './OrderItemCreateModalUI.js'

class OrderItemCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // create order item
      submitted: false,
      // product item id
      productItemId: '',
      productItemIdList: [],
      productItemIdError: null,
      productItemList: [],
      // quantity
      quantity: '',
      quantityError: null,
      // price
      price: '',
      // due date
      dueDate: '',
      dueDateError: null
    }
  }

  render() {
    return (
      <OrderItemCreateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // create mode
        createMode={this.props.createMode}
        // product item id
        productItemId={this.state.productItemId}
        productItemIdList={this.state.productItemIdList}
        onProductItemIdChange={this.onProductItemIdChange}
        productItemIdError={this.state.productItemIdError}
        // quantity
        quantity={this.state.quantity}
        onQuantityChange={(event) => { this.setState({ quantity: event.target.value }) }}
        quantityError={this.state.quantityError}
        setQuantityError={(event) => { this.setState({ quantityError: event.target.value }) }}
        // price
        price={this.state.price}
        // due date
        dueDate={this.state.dueDate}
        onDueDateChange={(selectedDateISO) => {
          this.setState({ dueDate: selectedDateISO })
        }}
        dueDateError={this.state.dueDateError}
        setDueDateError={(event) => { this.setState({ dueDateError: event.target.value }) }}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProductItems(context)
    this.getMessages(context)
  }

  onProductItemIdChange = (event) => {
    let productItem = this.state.productItemList.find(item => item.id === Number(event.target.value))
    this.setState({
      productItemId: event.target.value,
      price: productItem.salesRateF
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.post(this.props.context,
      `/api/accounts/${context.session.accountId}/estimates/${this.props.match.params.orderId}/estimateItems`,
      this.onSubmitCallback, {
      inventoryItemId: this.state.productItemId,
      quantity: this.state.quantity,
      dueDate: this.state.dueDate
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'itemId':
          this.setState({ productItemIdError: error.message })
          break;
        case 'quantity':
          this.setState({ quantityError: error.message })
          break;
        case 'dueDate':
          this.setState({ dueDateError: error.message })
          break;
        default:
      }
    })

    if (response.errorList.length !== 0) {
      this.setState({
        errorList: errorList,
        submitted: false,
      })

      return;
    }

    this.setState({
      successMsg: response.success,
      submitted: false,
      productItemId: '',
      quantity: '',
      price: '',
      dueDate: ''
    })

    setTimeout(() => {
      this.setState({ successMsg: null })
    }, 2000)
    this.props.onCreateComplete(response.estimate, response.estimateItemList)
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      productItemIdError: null,
      quantityError: null,
      dueDateError: null,
      submitted: false
    })
    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_create_order_item',
      'c_product',
      'c_add',
      'c_cancel',
      'c_quantity',
      'c_price',
      'c_due_date'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('ord_itm_crt', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }

  getProductItems(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/inventoryItems`,
      cacheKey: CacheKeys.InventoryItems(context.session.accountId),
      callback: this.getProductItemsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getProductItemsCallback = (response) => {
    if (response.inventoryItemList.length === 0) {
      // create page will not be reached without a customers
      // just redirect from here
      this.props.history.push('/settings/account/customers/create')
      return
    }

    let productItemList = response.inventoryItemList.map(item => ({
      key: item.id,
      value: item.name
    }))
    this.setState({
      productItemIdList: productItemList,
      productItemList: response.inventoryItemList
    })
  }
}

export default withRouter(OrderItemCreateModalSF)
